(() => {
  if (window.__genkidamaKd33Ready) return;
  window.__genkidamaKd33Ready = true;

  const selector = '[data-kd33-item-checkbox]';

  const selectedLines = () => {
    const lines = new Map();
    document.querySelectorAll(selector).forEach((checkbox) => {
      if (checkbox.checked && !lines.has(checkbox.value)) {
        lines.set(checkbox.value, Number(checkbox.dataset.lineTotal || 0));
      }
    });
    return lines;
  };

  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (_error) {
      return `${(cents / 100).toFixed(2).replace('.', ',')} EUR`;
    }
  };

  const updateSummaries = () => {
    const lines = selectedLines();
    const selectedTotal = Array.from(lines.values()).reduce((sum, value) => sum + value, 0);
    const deposit = Math.floor(selectedTotal * 33 / 100);
    const balance = selectedTotal - deposit;

    document.querySelectorAll('[data-kd33-summary]').forEach((summary) => {
      const cartTotal = Number(summary.dataset.cartTotal || 0);
      const currency = summary.dataset.currency || 'EUR';
      const shipping = Number(summary.dataset.kd33Shipping || 499);
      const totalWithShipping = cartTotal + shipping;
      const dueNow = cartTotal - balance + shipping;
      const totalNode = summary.querySelector('[data-kd33-total]');
      const dueNode = summary.querySelector('[data-kd33-due]');
      const balanceNode = summary.querySelector('[data-kd33-balance]');
      if (totalNode) totalNode.textContent = money(totalWithShipping, currency);
      if (dueNode) dueNode.textContent = money(dueNow, currency);
      if (balanceNode) balanceNode.textContent = money(balance, currency);
    });
  };

  const saveSelection = async () => {
    const keys = Array.from(selectedLines().keys());
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: { 'Genkidama Teilzahlung Positionen': keys.join('|') }
      })
    });
    if (!response.ok) throw new Error('Teilzahlungsauswahl konnte nicht gespeichert werden.');
  };

  document.addEventListener('change', async (event) => {
    const checkbox = event.target.closest(selector);
    if (!checkbox) return;

    document.querySelectorAll(selector).forEach((copy) => {
      if (copy.value === checkbox.value) copy.checked = checkbox.checked;
    });
    updateSummaries();

    document.documentElement.classList.add('kd33-is-saving');
    try {
      await saveSelection();
    } catch (error) {
      console.error(error);
      checkbox.checked = !checkbox.checked;
      document.querySelectorAll(selector).forEach((copy) => {
        if (copy.value === checkbox.value) copy.checked = checkbox.checked;
      });
      updateSummaries();
    } finally {
      document.documentElement.classList.remove('kd33-is-saving');
    }
  });

  document.addEventListener('DOMContentLoaded', updateSummaries);
})();